import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=d7d3a29c&scoped=true&"
import script from "./newDetails.vue?vue&type=script&lang=js&"
export * from "./newDetails.vue?vue&type=script&lang=js&"
import style0 from "./newDetails.vue?vue&type=style&index=0&id=d7d3a29c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d3a29c",
  null
  
)

export default component.exports